type SignalsLocation = {
    pathname: string;
    search: string;
    hash: string;
};

const legacyRouteRedirects = [
    {
        from: "/app/signals/topics",
        to: "/app/signals/drivers",
    },
    {
        from: "/app/reportsRv2",
        to: "/app/signals/reports",
    },
    {
        from: "/app/reports",
        to: "/app/signals/reports",
    },
] as const;

export function getCanonicalSignalsLocation({
    pathname,
    search,
    hash,
}: SignalsLocation): SignalsLocation | null {
    const redirect = legacyRouteRedirects.find(
        ({ from }) => pathname === from || pathname.startsWith(`${from}/`),
    );

    if (!redirect) {
        return null;
    }

    return {
        pathname: redirect.to + pathname.slice(redirect.from.length),
        search,
        hash,
    };
}

export const getDefaultSignalsHomePageRoute = (canViewDrivers: boolean) =>
    canViewDrivers
        ? "/app/signals/drivers/home"
        : "/app/signals/eddy/home";

export const getHomeDashboardIdFromHomePageRoute = (homePageRoute?: string) => {
    const dashboardRoute = homePageRoute
        ?.split("/home")[0]
        .split("/")
        .at(-1);

    return dashboardRoute === "topics" ? "drivers" : dashboardRoute;
};
